import React, { useEffect,useState,useRef } from 'react'
import SidebarOfAdash from '../../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal} from 'react-bootstrap'
import '../../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchtableApi } from '../../../../utils/AdminDashApi/Bill/BillApi'
import { optionsCampus, optionsShift, optionsStatusAI, optionsbilltype, optionssection } from '../../../Helper'
import Dropdown2 from '../../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import HeaderofAdash from '../../subComponent/HeaderofAdash';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const NewAdmissionEntryComp = () => {

    const navigate = useNavigate()
    const [flastname,setflastname] = useState("")    
    const [mlastname,setmlastname] = useState("")
    const currentDate = new Date()

   

    const [campusoptions, setcampusoptions] = useState("")
    
    const [semail, setsemail] = useState("")
    const [smobile, setsmobile] = useState("")
    const [dateofadmission, setdateofadmission] = useState("")
    const [dateofbirthstu, setdateofbirthstu] = useState("")
    const [sbirthcernum, setsbirthcernum] = useState("")
    const [labeladDate, setlabeladDate] = useState("")
    const [labelsession, setlabelsession] = useState("")
    const [labelsection, setlabelsection] = useState("")
    const [labelstatus, setlabelstatus] = useState("")
    const [drpsesstionselect, setdrpsession] = useState("")
    const [bordersection, setbordersection] = useState("")
    const [bordersession, setbordersession] = useState("")
    const [bordershift, setbordershift] = useState("")
    const [borderclass, setborderclass] = useState("")
    const [bordercampus, setbordercampus] = useState("")
    const [borderstatus, setborderstatus] = useState(false)
    const [borderbirthcernum, setborderbirthcernum] = useState(false)
    const [bordersfirstname, setbordersfirstname] = useState(false)
    const [bordersmiddlename, setbordersmiddlename] = useState(false)
    const [bordersbirthdt,setbordersbirthdt] = useState(false)
    const [bordersemail,setbordersemail] = useState(false)
    const [bordersmoblie,setbordersmobile] = useState(false)
    const [borderffirstname,setborderffirstname] = useState(false)
    const [bordermfirstname,setbordermfirstname] = useState(false)
    const [borderfmiddlename,setborderfmiddlename] = useState(false)
    const [bordermmiddlename,setbordermmiddlename] = useState(false)
    const [borderdateofadmission,setborderdateofadmission] = useState(false)
    

    
    const [labelsmobile, setlabelsmobile] = useState("")
    const [labelsemail, setlabelsemail] = useState("")
    const [labelshift, setlabelshift] = useState("")
    const [labelcampus, setlabelcampus] = useState("")
    const [labelsfirstname, setlabelsfirstname] = useState("")
    const [labelffirstname, setlabelffirstname] = useState("")
    const [labelmfirstname, setlabelmfirstname] = useState("")
    const [labelsmiddlename, setlabelsmiddlename] = useState("")
    const [labelfmiddlename, setlabelfmiddlename] = useState("")
    const [labelmmiddlename, setlabelmmiddlename] = useState("")
    const [labelslastname, setlabelslastname] = useState("")
    const [labeldateofbirthstu, setlabeldateofbirthstu] = useState("")
    const [labelsbirthcernum, setlabelsbirthcernum] = useState("")
    const [labeladmissiondate, setlabeladmissiondate] = useState("")
   
    
    const [classoptions, setclassoptions] = useState("")
    const [statusoptions, setstatusoptions] = useState("Active")
    const [labelclass, setlabelclass] = useState("")
    const [sectionoptions, setsectionoptions] = useState("")
    const [shiftoptions, setshiftoptions] = useState("")

    const [sfirstname,setsfirstname] = useState("")
    const [ffirstname,setffirstname] = useState("")
    const [fmiddlename,setfmiddlename] = useState("")
    const [mmiddlename,setmmiddlename] = useState("")
    const [mfirstname,setmfirstname] = useState("")
    const [smiddlename,setsmiddlename] = useState("")
    const [slastname,setslastname] = useState("")
    

    

    useEffect(()=>{
        console.log(sfirstname)
    },[sfirstname])
    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
    }
    const [sessionresponse, setsessionrsponse] = useState([]);
    const [classresponse, setclassresponse] = useState([]);
    const [campusresponse, setcampusresponse] = useState([]);
    const [shiftresponse, setshiftresponse] = useState([]);
    const [sectionresponseopt, setsectionresponseopt] = useState([]);
    const [saveresponse, setsaveresponse] = useState([]);

    const drpfunctionsesstion = (mysesstion, sesstionid) => {
        setdrpsession(sesstionid)
    }
    const drpfuncCampus = (myclassval, classid) => {
        setcampusoptions(classid)
    }
    const drpfuncClass =async (myclassval, classid) => {
        setclassoptions(classid)
        try {
            const sectionresponse = await axios.get(
                `https://localhost:7229/api/StudentEntry/GetSectionListByClass?ClassId=${classid}`,
                {},
                headers
            );
            setsectionresponseopt(sectionresponse.data);
            console.log(sectionresponse.data);
        } catch (err) {
            if (err.sectionresponse) {
                console.error(err.sectionresponse.data);
                console.log(err.sectionresponse.status);
                console.log(err.sectionresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    }
    const drpfuncSection = (mysectionval, sectionid) => {
        setsectionoptions(sectionid)
    }
    const drpfuncShift = (myshiftval, shiftid) => {
        setshiftoptions(shiftid)
    }
    const drpfuncStatus = (mystatusval, statusid) => {
        setstatusoptions(statusid)
    }
   

    const handleDateofadmission = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateofadmission(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }
    const handleDateofbirthstu = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateofbirthstu(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }

   
    
    useEffect(() => {
        const fetchSessionDropdown = async () => {
            try {
                const sessionresponse = await axios.get(
                    "https://sass.britishstandardschool.com/api/Public/SessionDropDown",
                    {},
                    headers
                );
                setsessionrsponse(sessionresponse.data);
                console.log(sessionresponse);
            } catch (err) {
                if (err.sessionresponse) {
                    console.error(err.sessionresponse.data);
                    console.log(err.sessionresponse.status);
                    console.log(err.sessionresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchSessionDropdown();
    }, []);
    useEffect(() => {
        const fetchClassDropdown = async () => {
            try {
                const classresponse = await axios.get(
                    "https://sass.britishstandardschool.com/api/Public/ClassList",
                    {},
                    headers
                );
                setclassresponse(classresponse.data);
                console.log(classresponse);
            } catch (err) {
                if (err.classresponse) {
                    console.error(err.classresponse.data);
                    console.log(err.classresponse.status);
                    console.log(err.classresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchClassDropdown();
    }, []);
    useEffect(() => {
        const fetchCampusDropdown = async () => {
            try {
                const campusresponse = await axios.get(
                    "https://localhost:7229/api/Public/CampusDropDown",
                    {},
                    headers
                );
                setcampusresponse(campusresponse.data);
                console.log(campusresponse);
            } catch (err) {
                if (err.campusresponse) {
                    console.error(err.campusresponse.data);
                    console.log(err.campusresponse.status);
                    console.log(err.campusresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchCampusDropdown();
    }, []);
    useEffect(() => {
        const fetchShitDropdown = async () => {
            try {
                const shiftresponse = await axios.get(
                    "https://localhost:7229/api/Public/ShiftDropDown",
                    {},
                    headers
                );
                setshiftresponse(shiftresponse.data);
               //console.log(shiftresponse);
            } catch (err) {
                if (err.shiftresponse) {
                    console.error(err.shiftresponse.data);
                    console.log(err.shiftresponse.status);
                    console.log(err.shiftresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchShitDropdown();
    }, []);

    const notification = {
        notification:true
    }

    const apiUrl = "https://localhost:7229/api/StudentEntry/NewAdmissionStudentEntry";
    const handleSave=(e)=>{
        e.preventDefault()

        // if (dateofadmission.length == 0) {
        //     setborderdateofadmission(true);
        //     setlabeladmissiondate("Date is required");
        //   } else {
        //     setborderdateofadmission(false);
        //     setlabeladmissiondate("");
            
        //   }

        if (sfirstname && sfirstname.length < 3 || sfirstname.length > 50) {
            setlabelsfirstname("3 to 50 characters")
            setbordersfirstname(true)
        } else if (sfirstname.length == 0) {
            setlabelsfirstname("First Name Required")
            setbordersfirstname(true)
        }else{
            setlabelsfirstname("")
            setbordersfirstname(false)
        }
        if (smiddlename && smiddlename.length < 3 || smiddlename.length > 50) {
            setlabelsmiddlename("3 to 50 characters")
            setbordersmiddlename(true)
        } else if (smiddlename.length == 0) {
            setlabelsmiddlename("Middle Name Required")
            setbordersmiddlename(true)
        }else{
            setlabelsmiddlename("")
            setbordersmiddlename(false)
        }

        if (dateofbirthstu.length == 0) {
            setbordersbirthdt(true);
            setlabeldateofbirthstu("Date is required");
          } else {
            setbordersbirthdt(false);
            setlabeldateofbirthstu("");
            
          }

          if (sbirthcernum.length > 0 && sbirthcernum.length < 17) {
            setlabelsbirthcernum("17 digits required")
            setborderbirthcernum(true)
        }
        else if (sbirthcernum.length == 0) {
            setlabelsbirthcernum("Birth certificate number required")
            setborderbirthcernum(true)
        }
        else {
            setlabelsbirthcernum("")
            setborderbirthcernum(false)
        }

        if (semail.length == 0) {
            setlabelsemail("Email is required")
            setbordersemail(true)
        }
        else if (semail && !/\S+@\S+\.\S+/.test(semail)) {
            setlabelsemail('Email format is incorrect')
            setbordersemail(true)
        }
        else {
            setlabelsemail('')
            setbordersemail(false)
        }
        if (smobile.length > 0 && smobile.length < 11) {
            setlabelsmobile("Mobile no must be 11 digits")
            setbordersmobile(true)
        } else if (smobile.length == 0) {
            setlabelsmobile("Mobile no is required")
            setbordersmobile(true)
        }
        else {
            setlabelsmobile("")
            setbordersmobile(false)
        }

        if (ffirstname && ffirstname.length < 3 || ffirstname.length > 50) {
            setlabelffirstname("3 to 50 characters")
            setborderffirstname(true)
        } else if (ffirstname.length == 0) {
            setlabelffirstname("First Name Required")
            setborderffirstname(true)
        }else{
            setlabelffirstname("")
            setborderffirstname(false)
        }
        if (fmiddlename && fmiddlename.length < 3 || fmiddlename.length > 50) {
            setlabelfmiddlename("3 to 50 characters")
            setborderfmiddlename(true)
        } else if (fmiddlename.length == 0) {
            setlabelfmiddlename("Middle Name Required")
            setborderfmiddlename(true)
        }else{
            setlabelfmiddlename("")
            setborderfmiddlename(false)
        }

        if (mfirstname && mfirstname.length < 3 || mfirstname.length > 50) {
            setlabelmfirstname("3 to 50 characters")
            setbordermfirstname(true)
        } else if (mfirstname.length == 0) {
            setlabelmfirstname("First Name Required")
            setbordermfirstname(true)
        }else{
            setlabelmfirstname("")
            setbordermfirstname(false)
        }
        if (mmiddlename && mmiddlename.length < 3 || mmiddlename.length > 50) {
            setlabelmmiddlename("3 to 50 characters")
            setbordermmiddlename(true)
        } else if (mmiddlename.length == 0) {
            setlabelmmiddlename("Middle Name Required")
            setbordermmiddlename(true)
        }else{
            setlabelmmiddlename("")
            setbordermmiddlename(false)
        }
        if(!drpsesstionselect){
            setbordersession("err")
            setlabelsession("Session Required")
        }else{
            setbordersession("")
            setlabelsession("")
        }
        if(!classoptions){
            setborderclass("err")
            setlabelclass("Class Required")
        }else{
            setborderclass("")
            setlabelclass("")
        }
        if(!sectionoptions){
            setbordersection("err")
            setlabelsection("Section Required")
        }else{
            setbordersection("")
            setlabelsection("")
        }
        if(!shiftoptions){
            setbordershift("err")
            setlabelshift("Shift Required")
        }else{
            setbordershift("")
            setlabelshift("")
        }
        if(!campusoptions){
            setbordercampus("err")
            setlabelcampus("Campus Required")
        }else{
            setbordercampus("")
            setlabelcampus("")
        }

        if(dateofadmission &&            
            sfirstname &&
            smiddlename &&
            dateofbirthstu &&
            semail &&
            smobile &&
            ffirstname &&
            fmiddlename &&
            mfirstname &&
            mmiddlename &&
            drpsesstionselect &&
            classoptions &&
            sectionoptions &&
            shiftoptions &&
            campusoptions &&
            sbirthcernum){

            const finalArr ={
                "firstName": sfirstname,
                "middleName": smiddlename,
                "lastName": slastname? slastname:"",
                "dob": dateofbirthstu,
                "birthCertificateNo": sbirthcernum,
                "email": semail,
                "mobile": smobile,
                "admissionDate": currentDate,
                "sessionId": drpsesstionselect,
                "classId": classoptions,
                "sectionId": sectionoptions,
                "shift": shiftoptions,
                "campusId": campusoptions,
                "status": true,
                "fatherFirstName": ffirstname,
                "fatherMiddleName": fmiddlename,
                "fatherLastName": flastname,
                "motherFirstName": mfirstname,
                "motherMiddleName": mmiddlename,
                "motherLastName": mlastname
            }
            console.log("Done",JSON.stringify(finalArr))
            axios.post(apiUrl, finalArr, headers)
            .then((response) => {
            console.log(response.data); 
            if (response.status == 200) {
                // navigate("/submitSuccess");
                setsaveresponse(response.data.value)
                toast.success('Your Changes Have Been Saved', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
              } else {
                navigate("/newadmissionentry");
              }
            })
            .catch((error) => {
            console.error(error);
        });
        }
        


        
    }

   const handleClearBtn=()=>{

   }
   

    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])
    
   
  return (
    <>
        <div className="f-flex flexvaluecomp">
            <SidebarOfAdash/>

            <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>
               
            <HeaderofAdash head="New Admission Entry"/>
            <div className=" contentflexvalue billcontent newadmissionentry">
                

                <div className="newadbox">
                    <div className="firstline">

                        <div className='left d-flex align-items-center'>
                            <h5>ID</h5>
                        </div>
                        <div className='right'>
                            <div className="idbox" >
                                <p style={{height:"25px"}}>{saveresponse?saveresponse :""}</p>
                            </div>
                        </div>
                    </div>

                    <div className="admissioninfo">
                    <div className="billbox paymentcollectbox stuCommonformbox">
                        <div className="titlewithwhite">
                            <p>Admission Entry</p>
                        </div>

                        <Row>
                            <Col lg={4} className='pe-0'>
                            <div className="basicinputfield h35p">
                                <p>Admission Date</p>
                             

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">
                                    <DatePicker
                                        value={currentDate}
                                        onChange={(newvaldob) => handleDateofadmission(newvaldob)}
                                        renderInput={(params) => (
                                        <TextField
                                            style={borderdateofadmission ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}}
                                            {...params}
                                            inputProps={{
                                            ...params.inputProps,
                                            placeholder: "",
                                            readOnly: true // Make the input non-editable
                                            }}
                                            error={false}
                                        />
                                        )}
                                    />
                                    <label>{labeladmissiondate}</label>
                                    </div>
                                </LocalizationProvider>
                                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateofadmission}
                                            onChange={(newvaldob) => handleDateofadmission(newvaldob)}
                                            renderInput={(params) => <TextField style={borderdateofadmission==true?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeladmissiondate}</label>
                                        
                                        
                                    </div>
                                </LocalizationProvider> */}
                            </div>
                        </Col>
                        <Col lg={8} className='pl10'>
                        <div className="basicinputfield h35p">
                            <p>Select Session</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={bordersession} func={drpfunctionsesstion} myplaceholder="Select Session" fontsize="12" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                                </div>
                                <label>{labelsession}</label>
                                
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pe-0'>
                        <div className="basicinputfield h35p">
                            <p>Class</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={borderclass} func={drpfuncClass} myplaceholder="" fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                <label>{labelclass}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='px10'>
                        <div className="basicinputfield h35p">
                            <p>Section</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordersection} func={drpfuncSection} myplaceholder="" fontsize="12" fontfamily="'Poppins', sans-serif" options={sectionresponseopt?sectionresponseopt:[]} />
                                </div>
                                <label>{labelsection}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='ps-0'>
                        <div className="basicinputfield h35p">
                            <p>Shift</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordershift} func={drpfuncShift} myplaceholder="" fontsize="12" fontfamily="'Poppins', sans-serif" options={shiftresponse} />
                                </div>
                                <label>{labelshift}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pe-0'>
                        <div className="basicinputfield h35p">
                            <p>Campus</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordercampus} func={drpfuncCampus} myplaceholder="" fontsize="12" fontfamily="'Poppins', sans-serif" options={campusresponse} />
                                </div>
                                <label>{labelcampus}</label>
                            </div>
                        </div>
                        </Col>

                        <Col lg={4} className='px10'>
                        <div className="basicinputfield h35p">
                            <p>Status</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2  err={borderstatus} func={drpfuncStatus} myplaceholder="Active" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsStatusAI} />
                                </div>
                                <label>{labelstatus}</label>
                            </div>
                        </div>
                        </Col>

                        </Row>
                        </div>

                    </div>

                    <div className="studentinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox">
                            <div className="titlewithwhite">
                                <p>Student Information</p>
                            </div>

                            <Row>
                                <Col lg={4} className='pe-0'>
                                    <div className="basicinputfield h35p">
                                        <p>First Name</p>
                                        <div className="inputgap h35">
                                            <input style={bordersfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={sfirstname} onChange={(e) => setsfirstname(e.target.value)} />
                                            <label>{labelsfirstname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='px10'>
                                    <div className="basicinputfield h35p">
                                        <p>Middle Name</p>
                                        <div className="inputgap h35">
                                            <input  style={bordersmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={smiddlename} onChange={(e) => setsmiddlename(e.target.value)} />
                                            <label>{labelsmiddlename}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='ps-0'>
                                    <div className="basicinputfield h35p">
                                        <p>Last Name</p>
                                        <div className="inputgap h35">
                                            <input type="text" value={slastname} onChange={(e) => setslastname(e.target.value)} />
                                            <label>{labelslastname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pe-0'>
                            <div className="basicinputfield h35p">
                                <p>Date of Birth</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateofbirthstu}
                                            onChange={(newvaldob) => handleDateofbirthstu(newvaldob)}
                                            renderInput={(params) => <TextField style={bordersbirthdt==true?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeldateofbirthstu}</label>
                                        
                                        
                                    </div>
                                </LocalizationProvider>
                            </div>
                            </Col>
                            <Col lg={8} className='pl10'>
                                <div className="basicinputfield h35p">
                                    <p>Birth Certificate No.</p>
                                    <div className="inputgap h35">
                                        <input style={borderbirthcernum ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={sbirthcernum} onChange={(e) => setsbirthcernum(e.target.value)} />
                                        <label>{labelsbirthcernum}</label>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} className='pe-0'>
                            <div className="basicinputfield h35p">
                                <p>Email</p>
                                
                                    <div className="inputgap h35">

                                    <input style={bordersemail ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={semail} onChange={(e) => setsemail(e.target.value)} />
                                        <label>{labelsemail}</label>
                                        
                                    </div>
                                
                            </div>
                            </Col>
                            <Col lg={6} className='pl10'>
                            <div className="basicinputfield h35p">
                                <p>Mobile</p>
                                
                                    <div className="inputgap h35">

                                    <input style={bordersmoblie ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={smobile} onChange={(e) => setsmobile(e.target.value)} />
                                        <label>{labelsmobile}</label>
                                        
                                    </div>
                                
                            </div>
                            </Col>
                            
                        </Row>
                        </div>
                    </div>
                    <div className="fathersinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox">
                            <div className="titlewithwhite">
                                <p>Father Information</p>
                            </div>
                            <Row>
                                <Col lg={4} className='pe-0'>
                                    <div className="basicinputfield h35p">
                                        <p>First Name</p>
                                        <div className="inputgap h35">
                                            <input style={borderffirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={ffirstname} onChange={(e) => setffirstname(e.target.value)} />
                                            <label>{labelffirstname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='px10'>
                                    <div className="basicinputfield h35p">
                                        <p>Middle Name</p>
                                        <div className="inputgap h35">
                                            <input style={borderfmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={fmiddlename} onChange={(e) => setfmiddlename(e.target.value)} />
                                            <label>{labelfmiddlename}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='ps-0'>
                                    <div className="basicinputfield h35p">
                                        <p>Last Name</p>
                                        <div className="inputgap h35">
                                            <input type="text" value={flastname} onChange={(e) => setflastname(e.target.value)} />
                                            
                                        </div>
                                    </div>
                                </Col>
                                </Row>

                        </div>
                    </div>
                    <div className="mothersinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox nomgbt20">
                            <div className="titlewithwhite">
                                <p>Mother Information</p>
                            </div>
                            <Row>
                                <Col lg={4} className='pe-0'>
                                    <div className="basicinputfield h35p">
                                        <p>First Name</p>
                                        <div className="inputgap h35">
                                            <input type="text"  style={bordermfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  value={mfirstname} onChange={(e) => setmfirstname(e.target.value)} />
                                            <label>{labelmfirstname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='px10'>
                                    <div className="basicinputfield h35p">
                                        <p>Middle Name</p>
                                        <div className="inputgap h35">
                                            <input  style={bordermmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mmiddlename} onChange={(e) => setmmiddlename(e.target.value)} />
                                            <label>{labelmmiddlename}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='ps-0'>
                                    <div className="basicinputfield h35p">
                                        <p>Last Name</p>
                                        <div className="inputgap h35">
                                            <input type="text" value={mlastname} onChange={(e) => setmlastname(e.target.value)} />
                                            
                                        </div>
                                    </div>
                                </Col>
                                </Row>

                        </div>
                    </div>
                </div>

                <div className="bottombarofsave">
                    <div className="wrapper newadmissionentrywrap">
                    <button onClick={handleClearBtn}>Clear</button>
                    
                    <button onClick={handleSave}>Save</button>
                    
                    </div>
                </div>
            </div>
            </div>
            <ToastContainer
            
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            />
            
        </div>
    </>
  )
}

export default NewAdmissionEntryComp